import { Link } from 'react-router-dom';
import './KitchenFittersPage.css';

const COLLECT = [
  {
    title: 'Gym Machines & Frames',
    image: '/images/gym-fitness/gym-machines-frames.png',
  },
  {
    title: 'Weight Plates & Bars',
    image: '/images/gym-fitness/gym-weights-bars.png',
  },
  {
    title: 'Treadmill Parts',
    image: '/images/gym-fitness/gym-treadmill-parts.png',
  },
  {
    title: 'Metal Racks & Benches',
    image: '/images/gym-fitness/gym-racks-benches.png',
  },
  {
    title: 'Metal Offcuts',
    image: '/images/gym-fitness/gym-metal-offcuts.png',
  },
  {
    title: 'Cardio Frames & Hardware',
    image: '/images/gym-fitness/gym-cardio-frames.png',
  },
];

const STEPS = [
  {
    n: '1',
    title: 'Post your scrap',
    body: 'Add photos, your postcode and what gym metal needs clearing from the site.',
  },
  {
    n: '2',
    title: 'We find collectors',
    body: 'Nearby licensed collectors review your listing and offer a collection window.',
  },
  {
    n: '3',
    title: 'Collector confirms',
    body: 'Agree access, parking and timing around your refit or clear-out day.',
  },
  {
    n: '4',
    title: 'Scrap is collected',
    body: 'Machines, weights and frames leave through licensed handling routes.',
  },
  {
    n: '5',
    title: 'You get more done',
    body: 'Your team stays on the refit while old gym metal is cleared away.',
  },
];

const REASONS = [
  {
    title: 'Licensed & verified collectors',
    body: 'Matched collectors are verified scrap carriers — not unlicensed tip runs.',
  },
  {
    title: 'Compliant & safe',
    body: 'Keep gym refits tidy with accountable collections for bulky metal kit.',
  },
  {
    title: 'Cost effective',
    body: 'Post for free and avoid losing time hauling machines and frames yourself.',
  },
  {
    title: 'Better for the environment',
    body: 'Gym metals are recovered for reuse instead of mixed waste streams.',
  },
  {
    title: 'Built for fitness sites',
    body: 'Share access notes and photos so collectors arrive ready for heavy equipment.',
  },
];

const TRUST = [
  { label: 'Save time', detail: 'Clear kit leftovers fast' },
  { label: 'Save money', detail: 'Free to post online' },
  { label: 'Recycle more', detail: 'Metal recovered properly' },
  { label: 'Stay compliant', detail: 'Licensed collectors only' },
];

export default function GymFitnessPage() {
  return (
    <div className="kf-page">
      <section className="kf-hero" aria-labelledby="gym-hero-heading">
        <div className="kf-hero-inner">
          <div className="kf-hero-copy">
            <p className="kf-kicker">SnapScrap for trade</p>
            <h1 id="gym-hero-heading">
              Scrap collection for <span>gym & fitness equipment</span>
            </h1>
            <p className="kf-lead">
              Clear machines, weights and gym metal quickly and responsibly — so your next refit or
              clear-out stays tidy and on schedule.
            </p>

            <div className="kf-hero-actions">
              <Link className="kf-btn" to="/post-scrap">
                Post scrap free →
              </Link>
              <Link className="kf-btn kf-btn-ghost" to="/how-it-works">
                See how it works
              </Link>
            </div>

            <ul className="kf-trust">
              {TRUST.map((item) => (
                <li key={item.label}>
                  <strong>{item.label}</strong>
                  <span>{item.detail}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="kf-hero-media">
            <img
              src="/images/businesses/biz-gym-fitness.png"
              alt="Gym and fitness equipment scrap ready for collection"
            />
            <p className="kf-hero-note">
              Built for gym refits — machines, weights, treadmills, racks and offcuts
            </p>
          </div>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="gym-collect-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="gym-collect-heading">What scrap we collect</h2>
            <p>Typical metal leftovers from gym refits, equipment swaps and clear-outs</p>
          </header>

          <ul className="kf-collect-grid">
            {COLLECT.map((item) => (
              <li key={item.title}>
                <div className="kf-collect-image">
                  <img src={item.image} alt="" loading="lazy" />
                </div>
                <h3>{item.title}</h3>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-section kf-section-tint" aria-labelledby="gym-steps-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="gym-steps-heading">How SnapScrap works</h2>
            <p>Five simple steps from posting leftovers to a clearer gym floor</p>
          </header>

          <ol className="kf-steps">
            {STEPS.map((step) => (
              <li key={step.n}>
                <span className="kf-step-n" aria-hidden="true">
                  {step.n}
                </span>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="gym-why-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="gym-why-heading">Why gyms & fitness sites choose SnapScrap</h2>
            <p>Clear space, keep refits moving, and handle metal the responsible way</p>
          </header>

          <ul className="kf-why-grid">
            {REASONS.map((item) => (
              <li key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-cta" aria-label="Post scrap call to action">
        <div className="kf-cta-inner">
          <div className="kf-cta-copy">
            <h2>Post your gym scrap for free today</h2>
            <p>
              List leftovers from your next equipment swap or gym clear-out and get matched with a
              licensed collector.
            </p>
          </div>
          <Link className="kf-btn kf-btn-light" to="/post-scrap">
            Post scrap free →
          </Link>
        </div>
      </section>
    </div>
  );
}
